import { dayjs } from "@lib";
import type { ReactNode } from "react";
import type { TableColumn } from "@/shared/components/table/table";
import { EventTypeBadge } from "../components/event-type-badge";
import type { EventListItem } from "../types/events";

export { renderEventsDetailRow } from "../events/components/event-expanded-detail";

/** Brazil does not observe DST since 2019, so a fixed UTC-3 offset is safe here. */
const BRAZIL_UTC_OFFSET_MINUTES = -180;

export function renderEventsCell(
	item: EventListItem,
	column: TableColumn<EventListItem>,
	_index: number
): ReactNode {
	const colId = column.id;

	switch (colId) {
		case "driver":
			return item.driver?.name ?? "";

		case "eventType":
			return <EventTypeBadge eventType={item.eventType} />;

		case "plate": {
			const plate = item.vehicle?.plate?.trim();

			return plate ? plate.replace(/-/g, "") : "";
		}

		case "model":
			return item.vehicle ? `${item.vehicle.model}`.trim() : "";

		case "start": {
			if (!item.start) {
				return "";
			}
			const date = dayjs.utc(item.start).utcOffset(BRAZIL_UTC_OFFSET_MINUTES);
			return (
				<div className="flex flex-col text-sm">
					<span>{date.format("DD/MM/YYYY")}</span>
					<span>{date.format("HH:mm")}</span>
				</div>
			);
		}

		default:
			return "";
	}
}
